<template>
    <div class="body">
        <div class="header">
            <h2 v-html="t.label_products"></h2>
            <dropdown
                :options="select__type.arrayOfObjects"
                :selected="select__type.name"
                :placeholder="t.label_all_time"
                :formatSecundary="true"
                v-on:updateOption="methodToRunOnSelect"
            ></dropdown>
        </div>
        <!-- <div class="list-group cards"> -->
        <div class="list-group cards" v-if="$parent.loading">
            <article class="card__sc list-group" v-for="i in 15" :key="i">
                <div class="topper">
                    <div class="infos">
                        <span></span>
                        <div class="infos__user">
                            <h2></h2>
                            <h3>
                                <span></span>
                                <span></span>
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="banner_out">
                </div>
                <div class="fotter">
                    <div class="first">
                        <span></span>
                        <span></span>
                        <div class="graphic">
                            <span></span>
                        </div>
                    </div>
                    <div class="second">
                        <div class="temperature"></div>
                    </div>
                </div>
            </article>
        </div>

        <div v-if="!$parent.loading && JSON.stringify($parent.allItems) == '[]'" v-html="t.label_not_found_item"></div>
        <section class="cards" v-if="!$parent.loading">
            <super-checkout-intern-card v-for="(el, index) in $parent.allItems" :key="index" :view="el" />
        </section>
        <a class="button" v-if="!$parent.loading && showLoadMore" @click="$parent.handleAllCardsMore()" v-html="t.label_load_more"></a>
        <super-checkout-intern-modal v-if="showModalCardSelected" :view="view" :modalCardSelectedID="modalCardSelectedID" :isAffiliate="view.data.is_affiliate" :idUser="view.data.dados_usuario_office.id"  :idUpline="view.data.dados_usuario_office.id_usuario_pai_rede_new || 209282"/>
    </div>
</template>

<script>
import dropdown from "./dropdown";
export default {
    name: "super-checkout-intern-body",
    props: ["view", "showLoadMore"],
    data(){
        return {
            t: this.view.translation,
            typeSelected: {
                id: null,
                name: null
            },
            select__type: {
                name: "",
                arrayOfObjects: [
                    { 
                        id: "all",
                        name: this.view.translation.label_all
                    },
                    {
                        id: "last-24h",
                        name: this.view.translation.label_last_24h
                    },
                    {
                        id: "last-week",
                        name: this.view.translation.label_last_week
                    },
                    {
                        id: "last-month",
                        name: this.view.translation.label_last_month
                    },
                    {
                        id: "last-year",
                        name: this.view.translation.label_last_year
                    },
                ],
            },
            showModalCardSelected: false,
            modalCardSelectedID: null
        }
    },
    components: {
        dropdown: dropdown,
    },
    mounted () {
        console.log('====================================');
        console.log(this.view.data.dados_usuario_office);
        console.log('====================================');
    },

    methods: {
        methodToRunOnSelect(payload) {
            this.typeSelected.id = payload.id;
            this.typeSelected.name = payload.name;
            this.$parent.handleAllCards(true, this.typeSelected.id);
        },
    },

    computed: {
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .body {
        width: 80%;
        margin: 0 auto;
        margin-top: 2rem;
        .header {
            display: flex;
            justify-content: space-between;
        }
        .cards {
            display: grid;
            grid-gap: 20px;
            grid-template-columns: repeat(auto-fill,minmax(320px,1fr));
            -webkit-transition: all .5s ease;
            transition: all .5s ease
        }
        a.button {
            padding: .8rem .5rem;
            color: #5B5B5B;
            background: white;
            font-weight: 600;
            margin: 0 auto;
            display: table;
            border-radius: 4px;
            margin-top: 2rem;
			&:hover {
				color: #191919;
			}
        }
    }
    @media (max-width: 450px) {
        .body {
            width: 95%;
            .cards {
                grid-template-columns: repeat(auto-fill,minmax(280px,1fr));
                grid-gap: 0px;
            }
        }
    }
    .list-group {
        min-height: 20px;
    }
    //shimmer loader
    @keyframes placeHolderShimmer{
        0%{
            background-position: -468px 0
        }
        100%{
            background-position: 468px 0
        }
    }
    .card__sc {
        background: #FFFFFF;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.12);
        border-radius: 4px;
        padding: 1rem 0;
        cursor: pointer;
        transition: .2s all;
        .topper .infos .infos__user__ico,
        .topper .infos span,
        .topper .infos .infos__user h2,
        .topper .infos .infos__user h3,
        .banner_out,
        .fotter .first span,
        .fotter .second .temperature {
            animation-duration: 1.25s;
            animation-fill-mode: forwards;
            animation-iteration-count: infinite;
            animation-name: placeHolderShimmer;
            animation-timing-function: linear;
            background: linear-gradient(to right, #edf1f5 8%, #f3f6f9 18%, #edf1f5 33%);
            background-size: 800px 104px;
            position: relative;
            border-radius: 4px;
        }


        .topper {
            display: flex;
            justify-content: space-around;
            align-items: flex-start;
            height: 30px;
            .infos {
                display: flex;
                align-items: center;
                span {
                    height: 30px;
                    width: 30px;
                    margin-right: .4rem;
                    border-radius: 30px;
                }
                .infos__user__ico {
                    margin-right: .4rem;
                    width: 36px;
                    border-radius: 30px;
                    height: 30px;
                }
                .infos__user {
                    display: flex;
                    flex-direction: column;
                    h2,
                    h3 {
                        height: 1.1rem;
                        width: 300px;
                        margin: 0;
                        color: #5B5B5B;
                    }
                    h2 {
                        font-size: 1.08rem;
                        font-weight: 600;
                    }
                    h3 {
                        font-size: .78rem;
                        margin-top: .4rem;
                        span {
                            font-size: 1em;
                            font-weight: 300;
                            &:first-child {
                                color: #C6C2C2;
                            }
                        }
                    }
                }
            }
        }
        .banner_out {
            width: 100%;
            height: 150px;
            margin-top: 2rem;
        }
        .fotter {
            display: flex;
            padding: 0 1rem;
            justify-content: space-between;
            height: 50px;
            .first {
                display: flex;
                flex-direction: column;
                margin-top: 7px;
                span {
                    height: 15px;
                    width: 250px;
                    font-size: .88rem;
                    &:nth-child(1) {
                        color: #434343;
                    }
                    &:nth-child(2) {
                        font-size: 1.1em;
                        color: #14C51B;
                        font-weight: 600;
                        margin: .2rem 0;
                    }
                }
                .graphic {
                    width: 100%;
                    border-radius: 1px;
                    height: 13px;
                }
            }
            .second {
                display: flex;
                align-items: center;
                .temperature {
                    height: 15px;
                    width: 100%;
                    color: white;
                    border-radius: 3px;
                    padding: .4rem 1.3rem;
                    margin-right: .7rem;
                    font-weight: 600;;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/super-checkout-intern/body.vue